import withRoot from './modules/withRoot';
// --- Post bootstrap -----
import React from 'react';
import ProductCategories from './modules/views/ProductCategories';
import ProductSmokingHero from './modules/views/ProductSmokingHero';
import AppFooter from './modules/views/AppFooter';
import ProductHero from './modules/views/ProductHero';
import ProductValues from './modules/views/ProductValues';
import ProductStrengths from './modules/views/ProductStrengths';
import ProductExpertise from './modules/views/ProductExpertise';
import ProductHowWeWork from './modules/views/ProductHowWeWork';
import ProductCTA from './modules/views/ProductCTA';
import AppAppBar from './modules/views/AppAppBar';

function Index() {
  return (
    <React.Fragment>
      <AppAppBar transparent position='absolute' hideHome={true} />
      <ProductHero />
      <ProductCategories />
      <ProductStrengths />
      <ProductExpertise />
      <ProductHowWeWork />
      <ProductSmokingHero />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
